
import * as React from 'react';
import { inject } from 'inversify';
import { resolve } from 'inversify-react';
import FormInput from './input';
import Icon from './icon';

export interface LateInputProps {
    delay: number;
    onChange: (text) => void;
    placeholder?: string;
}

export interface LateInputState {
  value: any;
}

export default class LateInput extends React.Component<LateInputProps, LateInputState> {
  
    constructor(props){
        super(props);

        this.state = {
            value: ''
        }
    }

  public render() {

    return (<div className="search-input">
            <Icon type='edit' faType='filter'/>
            <FormInput
                placeholder={this.props.placeholder}
                value={this.state.value}
                onChange={e => {
                    this.setState({value: e}, () => this.props.onChange(e))
                }}
            />
    </div>)
    
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/late-input.tsx